import {
  ChangeDetectionStrategy, Component, inject, signal,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from '../../../core/services/api.service';
import { ToastService } from '../../../core/services/toast.service';
import { API_ROUTES } from '../../../core/constants/api-routes';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, RouterLink],
})
export class ForgotPassword {
  private fb = inject(FormBuilder);
  private apiService = inject(ApiService);
  private toastService = inject(ToastService);
  private router = inject(Router);

  readonly isLoading = signal(false);
  readonly isSuccess = signal(false);
  readonly countdown = signal(3);

  forgotForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  private startCountdown(): void {
    let count = 3;
    this.countdown.set(count);
    const interval = setInterval(() => {
      count--;
      this.countdown.set(count);
      if (count <= 0) {
        clearInterval(interval);
        this.router.navigate(['/login']);
      }
    }, 1000);
  }

  async onSubmit(): Promise<void> {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.isLoading.set(true);
    const { email } = this.forgotForm.value;

    const resp = await this.apiService.request(
      'POST',
      API_ROUTES.FORGOT_PASSWORD,
      { email },
      { useToken: false, showToaster: false }
    );

    if (resp.status) {
      this.isSuccess.set(true);
      this.toastService.success(resp.message);
      this.startCountdown();
    } else {
      this.toastService.error(resp.message);
    }

    this.isLoading.set(false);
  }

  get f() { return this.forgotForm.controls; }
}
